import { Reveal } from "../components/Motion";
import { doctor } from "../lib/data";
import { Link } from "react-router-dom";
import { ArrowRight, GraduationCap, HeartHandshake, ShieldCheck, Microscope } from "lucide-react";

export default function About() {
  const pillars = [
    {
      icon: GraduationCap,
      title: "Лікар терапевт-косметолог",
      text: "Базова медична освіта та поглиблена спеціалізація в естетичній медицині, дерматології та anti-age.",
    },
    {
      icon: Microscope,
      title: "Сучасний підхід",
      text: "Доказова медицина, аналізи, протоколи провідних європейських клінік. Працюю з оригінальними сертифікованими препаратами.",
    },
    {
      icon: HeartHandshake,
      title: "Індивідуальна робота",
      text: "Кожен план — авторський. Без шаблонів. Враховую анамнез, спосіб життя, цілі та бажаний образ.",
    },
    {
      icon: ShieldCheck,
      title: "Wellness та anti-age",
      text: "Зовнішня краса — наслідок внутрішнього балансу. Працюю з метаболізмом, дефіцитами та харчовою поведінкою.",
    },
  ];

  return (
    <div data-testid="page-about">
      <section className="pt-32 md:pt-40 pb-16">
        <div className="container-luxe">
          <Reveal>
            <div className="overline mb-6">Про мене</div>
          </Reveal>
          <Reveal delay={0.05}>
            <h1 className="font-serif text-5xl md:text-7xl lg:text-[88px] leading-[0.95] tracking-tight max-w-4xl">
              {doctor.nameUa}
            </h1>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 text-warmGray text-lg max-w-2xl leading-relaxed">
              Лікар терапевт-косметолог, спеціалістка з anti-age медицини, wellness терапії
              та сучасних протоколів зниження ваги. Поєдную глибокий медичний підхід та
              витончену естетику.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-24">
        <div className="container-luxe grid lg:grid-cols-12 gap-10 items-start">
          <Reveal className="lg:col-span-6">
            <img loading="lazy" decoding="async" src={doctor.photos.portrait3}
              alt="Tetiana Zolotko"
              className="w-full h-[640px] object-cover rounded-3xl"
            />
          </Reveal>
          <div className="lg:col-span-6 space-y-6">
            <Reveal>
              <p className="text-ink text-lg leading-relaxed">
                Понад 10 років практики у сфері медичної косметології та anti-age медицини.
                Постійно навчаюсь у провідних європейських академіях — Medicalaser (EU),
                Biopell Medical (Польща), iS Clinical (США).
              </p>
            </Reveal>
            <Reveal delay={0.05}>
              <p className="text-warmGray leading-relaxed">
                Моя філософія — природна, нероблена краса. Я не змінюю обличчя пацієнтів —
                я допомагаю їм виглядати найкращою версією себе. Кожна процедура супроводжується
                ретельною діагностикою, аналізами та чесною розмовою про очікувані результати.
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="text-warmGray leading-relaxed">
                Окремий напрямок моєї практики — медична програма корекції ваги.
                Це не просто «уколи для схуднення», а комплексна робота з метаболізмом,
                дефіцитами, харчовою поведінкою та якістю життя. Метод терапії визначається
                індивідуально після консультації, оцінки аналізів, показань і протипоказань.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <Link
                to="/certificates"
                data-testid="about-certs-link"
                className="inline-flex items-center gap-2 text-[11px] tracking-[0.28em] uppercase border-b border-ink pb-1"
              >
                Сертифікати <ArrowRight size={14} strokeWidth={1.5} />
              </Link>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28 bg-sand/40">
        <div className="container-luxe">
          <Reveal>
            <div className="overline mb-3">Філософія</div>
            <h2 className="font-serif text-4xl md:text-5xl tracking-tight max-w-2xl">
              Чотири принципи моєї практики
            </h2>
          </Reveal>
          <div className="mt-14 grid md:grid-cols-2 gap-6 lg:gap-8">
            {pillars.map((p, i) => (
              <Reveal key={p.title} delay={i * 0.05}>
                <div className="p-8 md:p-10 rounded-3xl bg-bone border border-line h-full">
                  <p.icon size={28} strokeWidth={1.2} />
                  <h3 className="font-serif text-2xl md:text-3xl mt-6">{p.title}</h3>
                  <p className="text-warmGray text-sm md:text-base mt-3 leading-relaxed">{p.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
